export default __webpack_public_path__ + "static/media/videos-stop.9536cf59.svg";